import { css } from 'styled-components'

export const responsiveDetailContainer = css`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: hidden;

  @media screen and (max-width: 900px) {
    padding: 10px 16px 32px;
  }
`

export const responsiveDetailHeader = css`
  min-width: 0;
  box-sizing: border-box;

  > * {
    min-width: 0;
    max-width: 100%;
  }

  @media screen and (max-width: 1100px) {
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 10px;
    margin-right: 0;
  }
`

export const responsiveDetailActions = css`
  min-width: 0;
  max-width: 100%;

  @media screen and (max-width: 1100px) {
    flex-wrap: wrap;
    gap: 8px;
    margin-right: 0;
  }
`

export const responsiveDetailTitle = css`
  min-width: 0;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
`

export const responsiveDetailMeta = css`
  min-width: 0;
  max-width: 100%;
  flex-wrap: wrap;
  gap: 6px 0;

  > * {
    min-width: 0;
    max-width: 100%;
    overflow-wrap: anywhere;
  }

  @media screen and (max-width: 900px) {
    margin-bottom: 8px;
  }
`

export const responsiveDetailNav = css`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: clip;

  > div {
    right: 0;
    width: 100%;
    min-width: 0;
  }

  @media screen and (max-width: 900px) {
    margin-top: 16px;
    margin-right: 0;

    > div {
      position: relative;
      inset: auto;
      width: 100%;
    }
  }
`
